<section class="about-section about-illustration-img">
  <div class="container" *transloco="let t; read: 'home'">
    <div class="row no-gutters justify-content-lg justify-content-center">
      <div class="col-lg-6 col-md-10 m-auto">
        <div class="about-text">
          <div class="section-title left-border mt-5 mb-40">
            <h3 class="pb-3 text-center">
              {{ t("title1") }}
            </h3>
            <h2 class="title text-center">{{ t("title2") }}</h2>
          </div>
          <div class="row justify-content-center">
            <!-- <div class="col-auto">
              <a class="main-btn">Learn More</a>
            </div> -->
            <div class="col-auto">
              <a class="main-btn main-btn-3" [routerLink]="['', 'contact']">
                {{ t("button1") }}</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-10 m-auto">
        <div class="p-3">
          <img src="assets/img/illustration/01.png" alt="img" />
        </div>
      </div>
    </div>
    <div class="row justify-content-lg justify-content-center">
      <h4 class="p-3 text-center">
        {{ t("title3") }}
      </h4>
      <h3 class="text-center text-primary">
        {{ t("title4") }}
      </h3>
    </div>
  </div>
</section>
